// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_TestConnectionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for testing Odoo connection
 *
 * Response envelope:
 * {
 *   "success": true,
 *   "dados": {
 *     "success": true,
 *     "message": "Connection successful",
 *     "data": [{ "id": 1, "name": "Helpdesk" }]
 *   },
 *   "error": null
 * }
 *
 * The outer envelope `success` is always true when this endpoint reaches
 * the `sendResponse()` call (the controller catches helper exceptions and
 * routes them to `sendError()`). The inner `dados.success` mirrors the
 * helper's own success flag — useful when the helper completes without
 * throwing but the probe itself reports a non-OK Odoo response.
 *
 * `data` is the raw helpdesk.team search_read result (limit 1, fields
 * `id, name`) — typed via OdooTickets_TestConnectionTeamRow purely so
 * the Spatie transformer can emit a typed TS shape instead of falling
 * back to `unknown[]`. It is null when the helper sets it to null on
 * failure, but in that case the helper also throws, so the null branch
 * is defensive only.
 */
import type { OdooTickets_TestConnectionTeamRow } from './OdooTickets_TestConnectionTeamRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_TestConnectionResponseDados {
success: boolean
message: string
data?: OdooTickets_TestConnectionTeamRow[]
}

export type OdooTickets_TestConnectionResponse = ApiResponse<OdooTickets_TestConnectionResponseDados>;

registerResponseContract('OdooTickets_TestConnectionResponse', {
  success: { type: 'boolean', required: true },
  message: { type: 'string',  required: true },
  data: {
    type: 'array',
    required: false,
    items: {
      id:   { type: 'number',  required: true },
      name: { type: 'string',  required: true },
    },
  },
})
